<template>
  <nav class="ui left fixed vertical menu">
    <Spinny :promise="subjectsPromise" />
    <Placy
      v-if="!subjects.length"
      :promise="subjectsPromise"
      :empty-message="$t('NO_THING_YET', { thing: $tc('SUBJECT', 2) })"
      :error-message="$t('ERR', { action: $t('READ', { thing: $tc('SUBJECT', 2) }) })"
    />

    <!-- Search -->
    <div class="item" v-if="subjects.length > 10">
      <div class="ui icon input">
        <input
          type="text"
          :placeholder="$t('SEARCH')"
          v-model="searchTerm"
          autocomplete="off"
          @focus="searchFocused = true"
          @blur="searchFocused = false"
        />
        <i class="search icon"></i>
      </div>
    </div>

    <router-link class="item" :to="{ name: 'new-subject' }">
      <i class="plus icon"></i>
      <strong>{{ $t('NEW', { thing: $tc('SUBJECT', 1) }) }}</strong>
    </router-link>

    <router-link
      class="item"
      :active-class="'active'"
      :to="{ name: 'subject', params: { subjectId: subject.id } }"
      v-for="subject in filteredSubjects"
      :key="subject.id"
    >
      <div class="name ellipsis" :title="subject.name">{{ subject.name }}</div>
      <div class="key ellipsis" :title="subject.key">{{ subject.key }}</div>
      <div class="regex ellipsis" :title="subject.regex">{{ subject.regex }}</div>
    </router-link>
  </nav>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

nav {
  overflow-y: scroll;
}

.name {
  font-weight: bold;
  padding: 0 0 5px 0;
}

.regex,
.key {
  color: rgb(200, 200, 200);
  padding: 5px 0 0 0;
}

.regex {
  font-family: 'Fira Code', Menlo, Monaco, Consolas, monospace;
}
</style>

<script>
// @flow
import _ from 'lodash'
import Vue from 'vue'
import { Spinny, Placy } from 'ui'
import { Subject, Toast, Typenames } from 'services'
import { map, catchError } from 'rxjs/operators'
import { ActionTypes } from 'store'

export default {
  name: 'subject-list',
  components: { Spinny, Placy },

  data() {
    return {
      searchTerm: '',
      subjectsPromise: null
    }
  },

  computed: {
    subjects() {
      return this.$store.state.subject.items
    },
    subjectsByName() {
      return _.orderBy(this.subjects, 'name')
    },
    filteredSubjects() {
      return _.filter(
        this.subjectsByName,
        subject => subject.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1
      )
    }
  },

  created() {
    this.subjectsPromise = Subject.readAllSubjects()
  }
}
</script>
